import React, { useEffect, useState } from 'react'
import SubscriptionLock from '../../../../media/images/subscription-lock.svg'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import '../styles/Dashboard.scss'
import { useThemeMode } from '../../../../_metronic/partials'
import brandingConfig from '../../../../config/brandingConfig'
import { useAuth } from '../../auth'
import { getReactivateSubscriptionDetails } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'

const ActivateSubscription = () => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const { companyId } = useAuth()
  const [reactiveSubscriptionDetails, setReactiveSubscriptionDetails] = useState<any>()
  const [isLoading, setIsLoading] = useState(false)

  const getReactivateSubscription = async () => {
    setIsLoading(true)
    try {
      if (companyId) {
        const {
          data: { success, data },
        } = await getReactivateSubscriptionDetails(companyId)
        if (success) {
          setReactiveSubscriptionDetails(data)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (companyId) {
      getReactivateSubscription()
    }
  }, [companyId])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='bg-white activate-subscription rounded'>
      <div className='d-flex flex-column align-items-center justify-content-center gap-4 mb-4'>
        <img src={SubscriptionLock} alt='subscription lock' />
        <h1 className='mb-0 font-size-24 text-center'>
          {formatMessage({ id: 'Please activate your subscription' })}
        </h1>
        <div className=''>
          <p className='mb-0 text-center d-md-none d-block'>
            {formatMessage({
              id: 'Your account is currently locked due to a payment issue or subscription deactivation. But don’t worry—your data is safe.',
            })}
          </p>
          <p className='mb-0 text-center d-md-block d-none'>
            {formatMessage({ id: 'Your account is currently locked due to a payment issue or ' })}
          </p>
          <p className='mb-0 text-center d-md-block d-none'>
            {formatMessage({ id: 'subscription deactivation. But don’t worry—your data is safe.' })}
          </p>
        </div>
      </div>
      {/* <div className='d-flex flex-md-row flex-column align-items-center justify-content-center gap-2 mb-4'>
                <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100' >
                    <h1 className='mb-0 font-size-20'>{formatMessage({ id: '1,62,500' })}</h1>
                    <p className='mb-0 text-muted font-size-14'>{formatMessage({ id: 'Uploaded Files' })}</p>
                </div>
                <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100' >
                    <h1 className='mb-0 font-size-20'>{formatMessage({ id: '82' })}</h1>
                    <p className='mb-0 text-muted font-size-14'>{formatMessage({ id: 'Storage Connected' })}</p>
                </div>
                <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100' >
                    <h1 className='mb-0 font-size-20'>{formatMessage({ id: '3.6 GB' })}</h1>
                    <p className='mb-0 text-muted font-size-14'>{formatMessage({ id: 'Storage Utilized' })}</p>
                </div>
                <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100' >
                    <h1 className='mb-0 font-size-20'>{formatMessage({ id: '2' })}</h1>
                    <p className='mb-0 text-muted font-size-14'>{formatMessage({ id: 'Team Members' })}</p>
                </div>
            </div> */}
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-3 col-12 mb-7'>
            <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100 h-100'>
              {isLoading ?
                <>
                  <Skeleton
                    width={'100%'}
                    height={25}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    className=''
                  />
                </> :
                <h1 className='mb-0 font-size-20'>{reactiveSubscriptionDetails?.fileUploadCount}</h1>
              }
              <p className='mb-0 text-muted font-size-14'>
                {formatMessage({ id: 'Uploaded Files' })}
              </p>
            </div>
          </div>
          <div className='col-md-3 col-12 mb-7'>
            <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100 h-100'>
              {isLoading ?
                <>
                  <Skeleton
                    width={'100%'}
                    height={25}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    className=''
                  />
                </> :
                <h1 className='mb-0 font-size-20'>{reactiveSubscriptionDetails?.syncStorage}</h1>
              }
              <p className='mb-0 text-muted font-size-14'>
                {formatMessage({ id: 'Synced Storages' })}
              </p>
            </div>
          </div>
          <div className='col-md-3 col-12 mb-7'>
            <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100 h-100'>
              {isLoading ?
                <>
                  <Skeleton
                    width={'100%'}
                    height={25}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    className=''
                  />
                </> :
                <h1 className='mb-0 font-size-20'>{reactiveSubscriptionDetails?.storageUsed}</h1>
              }
              <p className='mb-0 text-muted font-size-14'>
                {formatMessage({ id: 'Storage Utilized' })}
              </p>
            </div>
          </div>
          <div className='col-md-3 col-12 mb-7'>
            <div className='card rounded-4 shadow-sm p-4 flex-fill w-md-auto w-100 h-100'>
              {isLoading ?
                <>
                  <Skeleton
                    width={'100%'}
                    height={25}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    className=''
                  />
                </> :
                <h1 className='mb-0 font-size-20'>{reactiveSubscriptionDetails?.totalTeamMembers}</h1>
              }
              <p className='mb-0 text-muted font-size-14'>{formatMessage({ id: 'Team Members' })}</p>
            </div>
          </div>
        </div>
        <div
          className='d-flex justify-content-center align-items-center'
          style={{ marginBottom: '60px' }}
        >
          <Link
            to='/setting/billing-invoice?tab=billing'
            className='btn btn-lg bg-primary text-white custom-button-property w-md-auto w-100'
          >
            {formatMessage({ id: 'Activate Subscription Now' })}
          </Link>
        </div>
      </div>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-5 col-12  mb-md-0 mb-4'>
            <div
              className='bg-primary bg-opacity-10 rounded px-4 py-5 d-flex flex-column gap-7'
              style={{ border: '1px solid rgba(13, 33, 109, 0.4)' }}
            >
              <h1 className='mb-0 font-size-16'>
                {formatMessage({ id: 'How to ensure you have an active subscription?' })}
              </h1>
              <div>
                <ul className='mb-0'>
                  <li className='font-size-12 fw-semibold'>
                    {formatMessage({ id: 'Update your payment details' })}
                  </li>
                  <li className='font-size-12 fw-semibold'>
                    {formatMessage({ id: 'Ensure your billing information is correct' })}
                  </li>
                  <li className='font-size-12 fw-semibold'>
                    {formatMessage({ id: 'Retry your renewal from billing tab' })}
                  </li>
                  <li className='font-size-12 fw-semibold'>
                    {formatMessage({
                      id: 'If your card has expired, update your payment method and retry',
                    })}
                  </li>
                </ul>
              </div>
              <div
                className='border-dashed border-warning rounded py-2 px-3'
                style={{ background: mode === 'dark' ? '#6C4F2C' : '#FFF8DD' }}
              >
                <p className='mb-0 font-size-12 fw-bold'>
                  {formatMessage({ id: `Need assistance? Visit our ` })}
                  <a
                    href={brandingConfig.helpDeskUrl}
                    className='text-primary text-decoration-underline'
                  >
                    {formatMessage({ id: 'Help Center' })}
                  </a>
                  {formatMessage({ id: ' or ' })}
                  <a
                    href={brandingConfig.customerSupportUrl}
                    className='text-primary text-decoration-underline'
                  >
                    {formatMessage({ id: 'Contact Support' })}
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-7 col-12 '>
            <div className='accordion lp-accordion' id='accordionExample'>
              <h1 className='font-size-16 mb-4'>
                {formatMessage({ id: 'Frequently Asked Questions' })}
              </h1>
              {/* Accodion Item 1  */}
              <div className='accordion-item mb-2 w-100'>
                <h2 className='accordion-header' id='heading-0'>
                  <button
                    className='accordion-button'
                    style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#collapse-0'
                    aria-expanded='false'
                    aria-controls='collapse-0'
                  >
                    <div className='d-flex align-items-center w-100'>
                      {/* header  */}
                      <h1 className={`font-size-14 fw-semibold mb-0`}>
                        {formatMessage({ id: `What happens to my files?` })}
                      </h1>
                    </div>
                  </button>
                </h2>

                {/* items collapes  content  */}
                <div
                  id='collapse-0'
                  className='accordion-collapse collapse'
                  aria-labelledby='heading-0'
                  data-bs-parent='#accordionExample'
                >
                  <div
                    className='accordion-body text-dark'
                    style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                  >
                    <div className='d-flex flex-md-row flex-column gap-8 align-items-center justify-content-between'>
                      <p className='mb-0 w-auto'>
                        {formatMessage({
                          id: `Your files remain secure and accessible on our platform for three months after your subscription cancellation. During this period, you can reactivate your subscription to regain full access. After three months, we reserve the right to delete your data to optimize platform performance and storage for active users. We recommend reactivating your subscription or downloading important files before this period ends.`,
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Accodion Item 2  */}
              <div className='accordion-item mb-2 w-100'>
                <h2 className='accordion-header' id='heading-0'>
                  <button
                    className='accordion-button'
                    style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#collapse-1'
                    aria-expanded='false'
                    aria-controls='collapse-1'
                  >
                    <div className='d-flex align-items-center w-100'>
                      {/* header  */}
                      <h1 className={`font-size-14 fw-semibold mb-0`}>
                        {formatMessage({ id: `How secure my files are?` })}
                      </h1>
                    </div>
                  </button>
                </h2>

                {/* items collapes  content  */}
                <div
                  id='collapse-1'
                  className='accordion-collapse collapse'
                  aria-labelledby='heading-1'
                  data-bs-parent='#accordionExample'
                >
                  <div
                    className='accordion-body text-dark'
                    style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                  >
                    <div className='d-flex flex-md-row flex-column gap-8 align-items-center justify-content-between'>
                      <p className='mb-0 w-auto'>
                        {formatMessage({
                          id: `Your files are protected with end-to-end encryption, ensuring maximum security at every stage. As a GDPR and ISO compliant organization, we implement industry-leading security protocols to safeguard your sensitive information. Our blockchain technology provides tamper-proof records with cryptographic security, giving you peace of mind that your documents remain confidential and protected from unauthorized access.`,
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Accodion Item 3  */}
              <div className='accordion-item mb-2 w-100'>
                <h2 className='accordion-header' id='heading-0'>
                  <button
                    className='accordion-button'
                    style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#collapse-2'
                    aria-expanded='false'
                    aria-controls='collapse-2'
                  >
                    <div className='d-flex align-items-center w-100'>
                      {/* header  */}
                      <h1 className={`font-size-14 fw-semibold mb-0`}>
                        {formatMessage({ id: `Can I Delete my Data & Account?` })}
                      </h1>
                    </div>
                  </button>
                </h2>

                {/* items collapes  content  */}
                <div
                  id='collapse-2'
                  className='accordion-collapse collapse'
                  aria-labelledby='heading-2'
                  data-bs-parent='#accordionExample'
                >
                  <div
                    className='accordion-body text-dark'
                    style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                  >
                    <div className='d-flex flex-md-row flex-column gap-8 align-items-center justify-content-between'>
                      <p className='mb-0 w-auto'>
                        {formatMessage({
                          id: `Yes! You can delete your files and account data at any time by contacting our support team through the Help Center. Our team will guide you through the process and ensure all your data is completely removed from our platform. We respect your right to data privacy and make the deletion process straightforward and transparent.`,
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActivateSubscription
